import {
  styled,
  Dialog as BaseDialog,
  IconButton as BaseIconButton,
  DialogContent as BaseDialogContent,
  Typography,
  Button as BaseButton,
} from '@mui/material'

export const Dialog = styled(BaseDialog)({
  '& .MuiDialog-paper': {
    position: 'relative',
  },
})

export const DialogTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[700],
  fontWeight: 400,
  fontSize: '24px',
  lineHeight: '28px',
  paddingBottom: theme.spacing(3),
}))

export const IconButton = styled(BaseIconButton)({
  position: 'absolute',
  top: 24,
  right: 24,
})

export const Button = styled(BaseButton)(({ theme }) => ({
  width: 'fit-content',
  marginTop: theme.spacing(3),
}))

export const DialogContent = styled(BaseDialogContent)(({ theme }) => ({
  paddingTop: theme.spacing(8),
  paddingLeft: theme.spacing(5),
  paddingRight: theme.spacing(5),
  paddingBottom: theme.spacing(5),
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
}))
